export default class Constants {
  static redeemPortfolios = ["DD", "ND", "NX", "DX", "CU", "CT"];
  static assetsRefIds = [59322, 59310, 61350, 59526, 61300, 59438, 61234];
}

export const ApprovalGroups: any = {
  A: "WM Support",
  B: "Compliance",
  C: "WM control",
};

export const WithdrawalGroups: any = {
  AMD: "Asset management",
  WMD: "Wealth management",
  OPS: "Operations",
  CEO: "CEO",
};

export const Colors = [
  "#2F4B7C",
  "#1283B7",
  "#53DEF7",
  "#4E6DDB",
  "#503F74",
  "#665191",
  "#9C8AE3",
  "#9A3F8E",
  "#A9BAF8",
  "#7C3372",
  "#9A3F8E",
  "#98558F",
  "#C85DB9",
  "#AC5E3B",
  "#D0724A",
  "#CD805E",
  "#FCA782",
  "#54A869",
  "#3AAF57",
  "#57D677",
  "#96ECAC",
  "#B58B3B",
  "#DEA02E",
  "#DDB56C",
  "#FFDC82",
  "#A73C68",
  "#994B6B",
  "#D45087",
  "#E47FA9",
  "#C54545",
  "#EA6262",
  "#FF8282",
  "#F29191",
];

export const currenyDecimals:any = {
  KWD: 3,
  USD: 2,
  EUR: 2,
  GBP: 2,
  SAR: 2,
  AED: 2,
  JOD: 3,
  EGP: 2,
  BHD: 3,
  QAR: 2,
  BHR: 3,
  LBP: 2,
  LYD: 3,
  OMR: 3,
  INR: 2,
  IQD: 3,
  ILS: 2,
  MYR: 2,
  TRY: 2,
  SYP: 2,
  MAD: 2,
  JPY: 0,
}

export const orderCurrency = [
  "KWD",
  "USD",
  "EUR",
  "GBP",
  "SAR",
  "AED",
  "JOD",
  "EGP",
  "BHD",
  "QAR",
  "BHR",
  "LBP",
  "LYD",
  "OMR",
  "INR",
  "IQD",
  "ILS",
  "MYR",
  "TRY",
  "SYP",
  "MAD",
  "JPY",
];

export const AssetsTitleByKey = {
  "UEQ": "Unlisted Securities",
  "DRO": "Derivatives - Options",
  "IBD": "Issued Bonds",
  "HSP": "Hedge Fund - Side Pockets",
  "PET": "Third Party Private Eqty",
  "DRV": "Derivatives",
  "OTH": "Others"
}

export enum BUSINESS_ACCOUNT_BRANCH {
  SA = 'Saudi Arabia',
  KW = 'Kuwait',
  AE = 'United Arab Emirates'
}